import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogsComponent } from './catalogs.component';
import { SharedModule } from '../../app/shared/shared.module';
import { DataTablesModule } from 'angular-datatables';
import { CatalogsRoutes } from './catalogs.routes';
import { CatCategoryPromoterComponent } from './components/cat-category-promoter/cat-category-promoter.component';
import { CatGoalRegionComponent } from './components/cat-goal-region/cat-goal-region.component';
import { CatGoalStateComponent } from './components/cat-goal-state/cat-goal-state.component';
import { NgxMaskModule } from 'ngx-mask';
import { CatEmployeeJobComponent } from './components/cat-employee-job/cat-employee-job.component';
import { CatPaymentFrequencyComponent } from './components/cat-payment-frequency/cat-payment-frequency.component';
import { CatProductCategoryComponent } from './components/cat-product-category/cat-product-category.component';
import { CatCollectRangeAmountComponent } from './components/cat-collect-range-amount/cat-collect-range-amount.component';
import { CatCommissionCalendarComponent } from './components/cat-commission-calendar/cat-commission-calendar.component';
import { CatFeeEmployeeJobComponent } from './components/cat-fee-employee-job/cat-fee-employee-job.component';
import { CatJobPositionBiComponent } from './components/cat-job-position-bi/cat-job-position-bi.component';
import { ScPromoterCategoryComponent } from './components/sc-promoter-category/sc-promoter-category.component';
import { ScGoalEmployeeJobComponent } from './components/sc-goal-employee-job/sc-goal-employee-job.component';
import { ScProductCategoryComponent } from './components/sc-product-category/sc-product-category.component';
import { ScProductSharedComponent } from './components/sc-product-shared/sc-product-shared.component';
import { ScProductDealerComponent } from './components/sc-product-dealer/sc-product-dealer.component';
import { ScProductCollectAmountComponent } from './components/sc-product-collect-amount/sc-product-collect-amount.component';
import { CatGoalEmployeeJobFisofoComponent } from './components/cat-goal-employee-job-fisofo/cat-goal-employee-job-fisofo.component';
import { CatSchemesComponent } from './components/cat-schemes/cat-schemes.component';

@NgModule({
  declarations: [
    CatalogsComponent,
    CatCategoryPromoterComponent,
    CatGoalRegionComponent,
    CatGoalStateComponent,
    CatEmployeeJobComponent,
    CatPaymentFrequencyComponent,
    CatProductCategoryComponent,
    CatCollectRangeAmountComponent,
    CatCommissionCalendarComponent,
    CatFeeEmployeeJobComponent,
    CatJobPositionBiComponent,
    ScPromoterCategoryComponent,
    ScGoalEmployeeJobComponent,
    ScProductCategoryComponent,
    ScProductSharedComponent,
    ScProductDealerComponent,
    ScProductCollectAmountComponent,
    CatGoalEmployeeJobFisofoComponent,
    CatSchemesComponent
  ],
  imports: [
    CatalogsRoutes,
    CommonModule,
    SharedModule,
    DataTablesModule,
    NgxMaskModule.forRoot()
  ]
})
export class CatalogsModule { }
